import React from 'react';
import PropTypes from 'prop-types';
import {get, first} from 'lodash';
import className from 'classnames';
import moment from 'moment';

import TableHeader from './TableHeader';
import DotTooltip from './DotTooltip';
import ImageLoader from './ImageLoader';
import PostsListItemVideo from './PostsListItemVideo';

const ChatFlat = ({
  messages = [],
  userId,
  total = 0,
}) => {
  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Messages of user id {userId}</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} messages</p>
        </div>

        <div className='MainHeader__right'>
          <a
            className='MainHeader__right__a MainHeader__right__a--switch'
            href={`/${gon.currentProvider}/users/${userId}/chats`}
          >
            Switch to chats view
          </a>
        </div>
      </div>

      <div
        className={className('Table', {
          'Table--chats-flat': true,
        })}
      >
        {(() => {
          let columnHeaders = [
            {
              label: 'ID',
            },
            {
              label: 'From user',
            },
            {
              label: 'Name',
            },
            {
              label: 'Chat room ID',
            },
            {
              label: 'Text',
            },
            {
              label: 'Created date',
            },
            {
              label: 'Type',
            },
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}
        {messages.map((message) => (
          <div
            className='Table__row'
            key={message.id}
            data-x={message}
          >
            <div className='Table__col'>{message.id}</div>

            <div className='Table__col'>
              <DotTooltip
                user={message.user}
              />
            </div>

            <div className="Table__col">{get(message, 'user.nickname')}</div>

            <div className="Table__col">{message.chatRoomId}</div>
            <div className="Table__col">
              {(() => {
                switch (message.messageType) {
                  case 'image':
                  case 'eternal_image':
                    return (
                      <div className='ImageBorder ImageBorder--square'>
                        <ImageLoader
                          klassName='ImageLoader--fixed-height'
                          renderAsImg
                          url={get(message, 'attachment.url')}
                        />
                      </div>
                    )
                  case 'video':
                    return (
                      <div className='ImageBorder ImageBorder--square'>
                        <PostsListItemVideo
                          video={{
                            videoUrl: get(message, 'videoUrl'),
                            thumbnailUrl: get(message, 'videoThumbnailUrl'),
                            height: 80,
                            width: 180
                          }}
                        />
                      </div>
                    )
                  default:
                    return message.text
                }
              })()}
            </div>

            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: message.createdAt !== null ?
                    moment(message.createdAt).format('YYYY-MM-DD<br />HH:mm')
                  :
                    'N/A'
                }
              }
            />

            <div className="Table__col">{message.messageType}</div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default ChatFlat;
